import { makeStyles } from "@mui/styles";
import { createTheme } from "@mui/material/styles";
const theme = createTheme();

const useDefaultStyles = makeStyles(() => ({
  mainContainer: {
    display: "flex",
  },
  examprofile: {
    width: "18%",

    "@media (max-width:599px)": {
      display: "none", // 📱 Mobile
    },
    "@media (min-width:600px) and (max-width:768px)": {
      display: "none", // 📲 Tablet Portrait
    },
    "@media (min-width:769px) and (max-width:1100px)": {
      width: "25%",
      // padding: "1rem",
      // background: "#FFF",
      // boxShadow: "0px 8px 15px #D7DAF2",
      // zIndex: "1200",
      // display: "flex",
      // flexDirection: "column", // 📲 Tablet Landscape
    },
  },
  examprofilemobile: {
    display: "none",
    [theme.breakpoints.down("xs")]: {
      display: "block",
    },
  },
  profileSection: {
    width: "18%",
    // height: "95vh",
    padding: "1rem 0.8rem",
    boxShadow: "0px 8px 15px #D7DAF2",
    zIndex: "1200",
  },
  profilesectioninner: {
    display: "flex",
  },
  imagecontainer: {
    width: " 40%",
    display: "flex",
    background: "#E0E0E2",
    borderRadius: "10px",
  },
  profilephoto: {
    aspectRatio: "1 / 1",
    borderRadius: "10px",
  },
  learnerinfo: {
    marginLeft: "0.5rem",
    "& .MuiTypography-body1": {
      color: "#000",
      fontFamily: "Plus Jakarta Sans",
      fontSize: "1rem",
      fontStyle: "normal",
      fontWeight: "600",
      textTransform: "capitalize",
      TextTrack: "wrap",
      [theme.breakpoints.down("xs")]: {
        fontSize: "0.9rem",
      },
    },
    "& .MuiTypography-body2": {
      color: "#000",
      fontFamily: "Satoshi",
      fontSize: "0.9rem",
      fontStyle: "normal",
      fontWeight: "500",
      textTransform: "capitalize",
    },
  },
  questionpallatemain: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  timer: {
    width: "80%",
    background: "#4565B7",
    borderRadius: "10px",
    padding: "0.7rem",
    margin: "0.5rem 0",
    textAlign: "center",
    "& .MuiTypography-h4": {
      color: "#FFF",
      fontFamily: "Playfair Display",
      fontSize: "0.875rem",
      fontStyle: "normal",
      fontWeight: "800",
      textTransform: "capitalize",
    },
  },
  numberbox: {
    background: "#F0F2FF",
    width: "80%",
    padding: "0.4rem",
    borderRadius: "6px",
  },
  numberboxhead: {
    background: "#4565B7",
    borderRadius: "6px 6px 0px 0px",
    padding: "0.7rem",
    "& .MuiTypography-h4": {
      color: "#FFF",
      fontFamily: "Playfair Display",
      fontSize: "0.875rem",
      fontStyle: "normal",
      fontWeight: "800",
      textTransform: "capitalize",
    },
  },
  questionNumberBoxmain: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    height: "40vh",
    overflow: "auto",
    "&::-webkit-scrollbar": {
      width: "8px",
    },

    /* Track */
    "&::-webkit-scrollbar-track": {
      boxShadow: "inset 0 0 5px grey",
      borderRadius: "10px",
    },

    /* Handle */
    "&::-webkit-scrollbar-thumb": {
      background: "#4565B7",
      borderRadius: "10px",
    },

    /* Handle on hover */
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#39476B",
    },
  },
  questionNumberBoxmaininner: {
    width: "95%",
  },
  questionNumberBox: {
    minWidth: "28px !important",
    height: "28px !important",
    // display: "flex",
    // justifyContent: "center",
    // alignItems: "center",
    padding: "0",
    margin: "0.3rem",
    backgroundColor: "#D7DAF2",
    borderRadius: "5px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#e0e0e0",
    },
    "&.selected": {
      backgroundColor: "#4565B7",
      color: "white",
      fontWeight: "bold",
    },
    "&.answered": {
      backgroundColor: "#04A10B",
      color: "white",
      fontWeight: "bold",
    },
    "&.marked": {
      backgroundColor: "yellow",
      color: "black",
      fontWeight: "bold",
    },
    "&.not_attempted": {
      backgroundColor: "#F26809",
      color: "white",
      fontWeight: "bold",
    },
    "&.not_viewed": {
      backgroundColor: "#FF0000",
      color: "white",
      fontWeight: "bold",
    },
    "&.marked_no_answer": {
      background: "Purple",
      color: "white",
      fontWeight: "bold",
    },
  },
  markedNoAnswer: {
    background: "Purple",
    color: "white",
    fontWeight: "bold",
  },
  exam: {
    width: "82%",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
    "@media (max-width:599px)": {
      width: "100%",
    },
    "@media (min-width:600px) and (max-width:768px)": {
      width: "100%",
      // 📲 Tablet Portrait
    },
  },
  examNameContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#4565B7",
    color: "white",
    padding: "0rem 1rem",
    boxShadow:
      "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
    "& .MuiTypography-body1": {
      color: "#FFF",
      textAlign: "center",
      fontFamily: "'Playfair Display', serif !important",
      fontSize: "1.875rem",
      fontStyle: "normal",
      fontWeight: "700",
      textTransform: "capitalize",

      "@media (max-width:599px)": {
        fontSize: "0.9rem",
      },

      "@media (min-width:600px) and (max-width:768px)": {
        fontSize: "0.9rem",
      },
      "@media (min-width:769px) and (max-width:1100px)": {
        fontSize: "0.9rem",
      },
    },
    "& .MuiInputBase-root": {
      fontSize: "0.8rem",
    },
    "& .MuiOutlinedInput-root": {
      background: "white",
      margin: "0.5rem",
    },
    "& .MuiOutlinedInput-input": {
      padding: "10.5px 30px 10.5px 14px",
      [theme.breakpoints.down("xs")]: {
        padding: "7.5px 20px 7.5px 5px",
      },
    },
    "& .MuiSelect-iconOutlined": {
      [theme.breakpoints.down("xs")]: {
        right: "0",
      },
    },
  },
  questionsContainer: {
    "& .MuiTypography-h6": {
      borderTop: "1px solid #797979",
      padding: "0.5rem 1rem",
      borderBottom: "1px solid #797979",
      background: "#D7DAF2",
      color: "#000",
      fontFamily: "'Playfair Display', serif !important",
      fontSize: "1.125rem",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "normal",
      textTransform: "uppercase",
    },
    "& .MuiTypography-h5": {
      color: "#00000",
      fontFamily: "'Jost', sans-serif",
      fontSize: "1.25rem",
      margin: "1rem 0.5rem ",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "normal",
      textTransform: "capitalize",
    },
  },
  sectionPalette: {
    padding: "1rem",
    display: "flex",
    overflowY: "auto",
    flexDirection: "row",
    gap: "8px",
  },
  transparentbtn2: {
    display: "none !important",
    background: "#FFF !important",
    border: "1px solid  #00000 !important",
    margin: "0 1rem !important",
    color: "#000 !important",
    "&:hover": {
      background: "#4565B7",
      border: "1px solid  #4565B7",
      color: "#FFF",
    },

    "@media (min-width:769px) and (max-width:1100px)": {
      fontSize:'0.7rem !important',
      display: "inline-block !important", // 📲 Tablet Portrait
    },
  },
  selectedQuestion: {
    width: "140px !important",
    margin: "0 0.5rem !important",
    padding: "0.5rem !important",
    background: "#4565B7 !important",
    borderRadius: "6px !important",
    color: "#FFF !important",
    fontFamily: "'Jost', sans-serif",
    fontSize: "1rem !important",
    fontStyle: "normal !important",
    fontWeight: "700 !important",
    lineHeight: "normal !important",
    textTransform: "capitalize !important",
    border: "1px solid  #4565B7 !important",
    boxShadow: "none",
    boxShadow:
      "0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)",
    "&:hover": {
      background: "#4565B7 !important",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.7rem",
    },
    "@media (max-width:599px)": {
      fontSize: "0.7rem !important",
    },
    "@media (min-width:600px) and (max-width:768px)": {
      fontSize: "0.7rem !important",
    },
    "@media (min-width:769px) and (max-width:1100px)": {
      fontSize: "0.7rem !important",
    },
  },

  unselectedQuestion: {
    width: "140px !important",
    margin: "0 0.5rem !important",
    padding: "0.5rem !important",
    background: "#FFF !important",
    border: "1px solid  #303030 !important",
    borderRadius: "6px !important",
    color: "#000 !important",
    fontFamily: "'Jost', sans-serif !important",
    fontSize: "1rem !important",
    fontStyle: "normal !important",
    fontWeight: "700 !important",
    lineHeight: "normal !important",
    textTransform: "capitalize !important",
    boxShadow: "none !important",
    "&:hover": {
      background: "#4565B7 !important",
      color: "#FFF !important",
      border: "1px solid  #4565B7 !important",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.7rem",
    },
    "@media (max-width:599px)": {
      fontSize: "0.7rem !important",
    },
    "@media (min-width:600px) and (max-width:768px)": {
      fontSize: "0.7rem !important",
    },
    "@media (min-width:769px) and (max-width:1100px)": {
      fontSize: "0.7rem !important",
    },
  },

  btncontainerinner: {
    width: "50%",
    display: "flex",
    justifyContent: "flex-end",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "flex-end",
    },
    "@media (max-width:599px)": {
      flexDirection: "column",
      alignItems: "flex-end",
    },
  },
  btncontainer: {
    display: "flex",
    flexDirection: "column",
    width: "75%",
    position: "fixed",
    bottom: "10px",

    [theme.breakpoints.down("xs")]: {
      width: "90%",
      bottom: "-30px",
      left: "50%",
      transform: "translate(-50%, -50%)",
    },
    "@media (max-width:599px)": {
      width: "90%",
      bottom: "-60px",
      left: "50%",
      transform: "translate(-50%, -50%)",
    },
    "@media (min-width:600px) and (max-width:768px)": {
      width: "90%",
      bottom: "-40px",
      left: "50%",
      transform: "translate(-50%, -50%)",
    },
  },
  mobileSaveContainer: {
    width: "100%",
    display: "none", // Hidden by default
    "@media (max-width:599px)": {
      display: "flex", // Show only on mobile
      justifyContent: "center",
      marginBottom: theme.spacing(1),
    },
    "@media (min-width:600px) and (max-width:768px)": {
      display: "flex", // Show only on mobile
      justifyContent: "center",
      marginBottom: theme.spacing(1),
    },
  },
  regularButtonsContainer: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    "@media (max-width:599px)": {
      flexWrap: "wrap",
    },
    "@media (min-width:600px) and (max-width:768px)": {
      flexWrap: "wrap",
    },
  },
  leftButtons: {
    display: "flex",
    gap: theme.spacing(1),
    "@media (max-width:599px)": {
            width: "100%",

    },
    "@media (min-width:600px) and (max-width:768px)": {
      width: "100%",
    },
  },
  rightButtons: {
    display: "flex",
    gap: theme.spacing(1),
    "@media (max-width:599px)": {
      width: "100%",
    },
    "@media (min-width:600px) and (max-width:768px)": {
      width: "100%",
    },
  },
  // Hide the desktop save button on mobile
  transparentbtnsave: {
    "@media (max-width:599px)": {
      display: "none",
    },
    "@media (min-width:600px) and (max-width:768px)": {
      display: "none",
    },
  },
  // Style for mobile save button
  transparentbtnsavemobile: {
    "@media (max-width:599px)": {
      display: "none",
    },
    "@media (min-width:600px) and (max-width:768px)": {
      display: "none",
    },
  },
  btncontainermobile: {
    display: "none",
    "@media (max-width:599px)": {
      display: "flex",
      width: "100%",
      bottom: "100px",
      position: "absolute",
      justifyContent: "center",
    },
    [theme.breakpoints.down("xs")]: {
      display: "flex",
      width: "100%",
      bottom: "100px",
      position: "absolute",
      justifyContent: "center",
      // left: "50%",
      // transform: "translate(-50%, -50%)",
    },
  },
  bluebtn: {
    background: "#4565B7  !important",
    border: "1px solid  #4565B7  !important",
    margin: "0 1rem  !important",
    color: "#FFF  !important",
    "&:hover": {
      background: "#4565B7",
      border: "1px solid  #4565B7",
      color: "#FFF",
    },
    "@media (max-width:599px)": {
      fontSize: "0.7rem  !important",
      marginBottom: "0.7rem  !important",
      margin: "0rem  !important",
      width: "90%  !important",
      background: "#FFF",
      border: "1px solid  #303030  !important",
      color: "#000",
      "&:hover": {
        background: "#4565B7",
        border: "1px solid  #4565B7",
        color: "#FFF",
      },
    },
    "@media (min-width:600px) and (max-width:768px)": {
      fontSize: "0.7rem  !important",
      marginBottom: "0.7rem  !important",
      margin: "0rem  !important",
      width: "90%  !important",
      background: "#FFF",
      border: "1px solid  #303030  !important",
      color: "#000",
      "&:hover": {
        background: "#4565B7",
        border: "1px solid  #4565B7",
        color: "#FFF",
      },
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.7rem  !important",
      marginBottom: "0.7rem  !important",
      margin: "0rem  !important",
      width: "90%  !important",
      background: "#FFF",
      border: "1px solid  #303030  !important",
      color: "#000",
      "&:hover": {
        background: "#4565B7",
        border: "1px solid  #4565B7",
        color: "#FFF",
      },
    },
  },
  transparentbtn: {
    background: "#FFF !important",
    border: "1px solid  #00000 !important",
    margin: "0 1rem !important",
    color: "#000 !important",
    "&:hover": {
      background: "#4565B7",
      border: "1px solid  #4565B7",
      color: "#FFF",
    },
    "@media (max-width:599px)": {
      fontSize: "0.7rem  !important",
      width: "90%  !important",
      marginBottom: "0.7rem  !important",
      margin: "0  !important",
      "&:hover": {
        background: "#FFF",
        border: "1px solid  #303030",
        color: "#000",
      },
    },
    "@media (min-width:600px) and (max-width:768px)": {
      fontSize: "0.7rem  !important",
      width: "90%  !important",
      marginBottom: "0.7rem  !important",
      margin: "0  !important",
      "&:hover": {
        background: "#FFF",
        border: "1px solid  #303030",
        color: "#000",
      },
    },
  },
  transparentbtnsave: {
    background: "#FFF !important",
    border: "1px solid  #00000 !important",
    margin: "0 1rem !important",
    color: "#000 !important",
    "&:hover": {
      background: "#4565B7",
      border: "1px solid  #4565B7",
      color: "#FFF",
    },
    "@media (max-width:599px)": {
      display: "none  !important",
      fontSize: "0.7rem  !important",
      width: "90%  !important",
      marginBottom: "0.7rem  !important",
      margin: "0  !important",
      "&:hover": {
        background: "#FFF",
        border: "1px solid  #303030",
        color: "#000",
      },
    },
    "@media (min-width:600px) and (max-width:768px)": {
      display: "none  !important",
      fontSize: "0.7rem  !important",
      width: "90%  !important",
      marginBottom: "0.7rem  !important",
      margin: "0  !important",
      "&:hover": {
        background: "#FFF",
        border: "1px solid  #303030",
        color: "#000",
      },
    },
  },
  transparentbtnsavemobile: {
    background: "#FFF !important",
    border: "1px solid  #00000 !important",
    margin: "0 1rem !important",
    color: "#000 !important",
    "&:hover": {
      background: "#4565B7",
      border: "1px solid  #4565B7",
      color: "#FFF",
    },
    "@media (max-width:599px)": {
      display: "flex  !important",
      fontSize: "0.7rem  !important",
      width: "90%  !important",
      marginBottom: "0.7rem  !important",
      margin: "0  !important",
      "&:hover": {
        background: "#FFF",
        border: "1px solid  #303030",
        color: "#000",
      },
    },
    "@media (min-width:600px) and (max-width:768px)": {
      display: "flex  !important",
      fontSize: "0.7rem  !important",
      width: "90%  !important",
      marginBottom: "0.7rem  !important",
      margin: "0  !important",
      "&:hover": {
        background: "#FFF",
        border: "1px solid  #303030",
        color: "#000",
      },
    },
    // [theme.breakpoints.down("xs")]: {
    //   display: "flex  !important",
    //   fontSize: "0.7rem  !important",
    //   width: "90%  !important",
    //   marginBottom: "0.7rem  !important",
    //   margin: "0  !important",
    //   "&:hover": {
    //     background: "#FFF",
    //     border: "1px solid  #303030",
    //     color: "#000",
    //   },
    // },
  },
  questionsContainerinner: {
    height: "68vh",
    paddingLeft: "1rem",
    marginTop: "1rem",
    overflow: "auto",
    "&::-webkit-scrollbar ": {
      display: "none",
    },
    [theme.breakpoints.down("xs")]: {
      height: "58vh",
    },

    "@media (max-width:599px)": {
      height: "58vh",
    },
  },
  questiontext: {
    color: "#00000",
    fontFamily: "'Jost', sans-serif",
    fontSize: "0.9rem",
    marginLeft: "2rem",
    fontStyle: "normal",
    marginTop :"1rem",
    fontWeight: "500",
    lineHeight: "normal",

    "& p": {
      margin: "0rem 1rem",
    },
    [theme.breakpoints.down("xs")]: {
      "& img": {
        maxWidth: "100%",
        width: "auto",
      },
    },
  },
  options: {
    color: "#000000",
    fontFamily: "'Jost', sans-serif",
    fontSize: "0.875rem",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal",
    marginLeft: "2.5rem",
    "& input": {
      margin: "0.5rem 1rem",
    },
    "& img": {
      maxWidth: "100%",
      height: "auto",
      "@media (max-width:599px)": {
        maxWidth: "85% !important",
        width: "auto !important",
      },
    },
    "& li": {
      margin: "1rem 0.5rem ",
      listStyle: "upper-latin",
      "&::marker": {
        verticalAlign: "middle",
      },
      "& label": {
        display: "flex",
        "& span": {
          "& p": {
            margin: "0",
          },
        },
      },
    },
  },
  p1: {
    padding: "1rem",
  },
  finalpopup: {
    padding: "1rem 1rem 0 1rem",
    "& .MuiTypography-h6": {
      color: "#263238",
      fontFamily: "Satoshi",
      fontSize: "2rem",
      fontStyle: "normal",
      fontWeight: "700",
      textTransform: "capitalize",
    },
  },
  bgwhite: {
    // height: "40vh",
    background: "white",
    border: "1px solid #D7DAF2",
    borderRadius: "6px",
  },
  legend: {
    width: "100%",
    marginTop: "0.5rem",
    display: "flex",
    flexWrap: "wrap",
  },
  legendinner: {
    width: "50%",
    display: "flex",
    alignItems: "center",
    "& .MuiTypography-body1": {
      color: "#000000",
      fontSize: "0.9rem",
      fontFamily: "'Jost', sans-serif",
      fontWeight: "400",
      lineHeight: "1.5",
      letterSpacing: "0.00938em",
    },
    "& span": {
      margin: "0.2rem",
      minWidth: "15px",
      minHeight: "15px",
    },
  },
  legendinner2: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    marginTop: "0.1rem",
    "& .MuiTypography-body1": {
      color: "#000000",
      fontSize: "0.9rem",
      fontFamily: "'Jost', sans-serif",
      fontWeight: "400",
      lineHeight: "1.5",
      letterSpacing: "0.00938em",
    },
    "& span": {
      margin: "0.2rem",
      minWidth: "15px",
      minHeight: "15px",
    },
  },
  attempted: {
    background: "#04A10B",
  },
  notanswered: {
    background: "#F26809",
  },
  markedanswer: {
    background: "yellow",
  },
  markednotanswer: {
    background: "Purple",
  },
  notviewed: {
    background: "#D7DAF2",
  },
  current: {
    backgroundColor: "#4565B7",
  },
  quilladdsinglequestion: {
    width: "50%",
    marginLeft: "1rem",
    "& .ql-toolbar.ql-snow": {
      borderRadius: " 6px 6px 0px 0px",
    },
    "& .ql-toolbar.ql-snow+.ql-container.ql-snow": {
      borderRadius: "0px 0px 6px 6px",
    },
    "& .ql-editor": {
      minHeight: "10em",
    },
    "& .ql-editor img": {
      maxWidth: "100px",
      height: "auto",
    },
  },
  numberInput: {
    marginLeft: "1rem",
    width: "15%",
    padding: "0.5rem",
    // [theme.breakpoints.down("xs")]: {
    // width: "40%",
    // },
    "@media (max-width:599px)": {
      width: "40%",
    },
  },
  dflex: {
    display: "flex !important",
  },
  flexdirectioncolumn: {
    flexDirection: "column !important",
  },
  root: {
    display: "flex",
  },
}));

export default useDefaultStyles;
